import Base from './Base';

class Contests extends Base {
    participate(id, data, opts = null) {
        return this.postJSONWithSession(`/contests/${id}`, data, opts);
    }
}

export default Contests;
